<section id="section-why-finzy" class="row">
  <div class="row">
    <h2 class="heading col-xs-10 col-xs-offset-1">How It Works</h2>
  </div>

  <div class="row">
    <p class="subheading col-xs-10 col-xs-offset-1">finzy makes the entire borrowing process simple and user friendly.
      You can get your loan funded in as less as 48 hours.</p>
  </div>

  <div class="row">
    <div class="col-xs-10 col-xs-offset-1 display-flex justify-center">
      <div class="big-number-layout">
        <span class="big-number text-color-faded-blue">1</span>
        <span class="big-number-label">Apply for a loan in 5 mins</span>
      </div>

      <div class="big-number-layout">
        <span class="big-number text-color-faded-blue">2</span>
        <span class="big-number-label">Approval in 1 business day</span>
      </div>

      <div class="big-number-layout">
        <span class="big-number text-color-faded-blue">3</span>
        <span class="big-number-label">Sign loan documents</span>
      </div>

      <div class="big-number-layout">
        <span class="big-number text-color-faded-blue">4</span>
        <span class="big-number-label">Loan disbursal</span>
      </div>

      <div class="big-number-layout">
        <span class="big-number text-color-faded-blue">5</span>
        <span class="big-number-label">Pay in easy EMIs with auto debit</span>
      </div>
    </div>
  </div>
</section>
